module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO54Tipsa.7b3b00b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO54Tipsa.mp4
// module id = 780
// module chunks = 1